import React, { useState } from 'react';
import MainPage from '../../composents/MainPage';
import Btn from '../../ui/Btn';
import resources from '../../services';
import moment from 'moment';
import Select from 'react-select';
import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
} from 'recharts';

const datas = [
	{
		name: 'Page A',
		uv: 4000,
		pv: 2400,
		amt: 2400,
	},
	{
		name: 'Page B',
		uv: 3000,
		pv: 1398,
		amt: 2210,
	},
	{
		name: 'Page C',
		uv: 2000,
		pv: 9800,
		amt: 2290,
	},
	{
		name: 'Page D',
		uv: 2780,
		pv: 3908,
		amt: 2000,
	},
	{
		name: 'Page E',
		uv: 1890,
		pv: 4800,
		amt: 2181,
	},
	{
		name: 'Page F',
		uv: 2390,
		pv: 3800,
		amt: 2500,
	},
	{
		name: 'Page G',
		uv: 3490,
		pv: 4300,
		amt: 2100,
	},
];

const title = 'Statistics';
const headers = {
	icon: 'feather icon-bar-chart-2',
	title: title,
	description: 'track all information',
};

const optionsMonth = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((e) => {
	return {
		value: e,
		label: moment().month(e).format('MMMM'),
	};
});

let optionsYear = [];
for (let i = 2021; i <= moment().year(); i++) {
	optionsYear.push({
		label: i,
		value: i,
	});
}

export default function AccountigPage() {
	const [filter, setFilter] = useState(false),
		[rsKey, setRSKey] = useState(false),
		[reKey, setREKey] = useState(false),
		[type, setType] = useState({
			value: 'month',
			label: 'Monthly',
		}),
		[optionYear, setOptionYear] = useState({
			value: moment().year(),
			label: moment().year(),
		}),
		[optionYearTo, setOptionYearTo] = useState({
			value: moment().year(),
			label: moment().year(),
		}),
		[optionMonthFrom, setOptionMonthFrom] = useState({
			value: moment().startOf('years').month(),
			label: moment().startOf('years').format('MMMM'),
		}),
		[optionMonthTo, setOptionMonthTo] = useState({
			value: moment().endOf('years').month(),
			label: moment().endOf('years').format('MMMM'),
		}),
		[data, setData] = useState([]);

	async function filerArticle(e) {
		e.preventDefault();

		let formData = new FormData(e.target);
		const value = Object.fromEntries(formData.entries());
		let params = '?';
		for (let key in value) {
			if (value[key].length > 0) {
				params = `${params}${key}=${value[key]}&`;
			}
		}
		await get(params);
	}

	const get = async (params = '') => {
		setFilter(true);
		let response = await resources.stats
			.accounting(params)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (response.status === 200) {
			setData(response.data);
		}
		setFilter(false);
	};

	const optionsTo = () => {
		const options = optionsMonth.filter(
			(e) => e.value >= optionMonthFrom.value
		);
		return options;
	};

	const onClear = () => {
		setOptionMonthFrom({
			value: moment().startOf('years').month(),
			label: moment().startOf('years').format('MMMM'),
		});
		setOptionMonthTo({
			value: moment().endOf('years').month(),
			label: moment().endOf('years').format('MMMM'),
		});
		setOptionYear({
			value: moment().year(),
			label: moment().year(),
		});
		setOptionYearTo({
			value: moment().year(),
			label: moment().year(),
		});
		setRSKey((e) => !e);
		setREKey((e) => !e);
	};

	const onTypeChange = (e) => {
		onClear();
		setType(e);
	};

	return (
		<MainPage headers={headers}>
			<form onSubmit={filerArticle}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-12">
						<div className="card">
							<div className="row card-body">
								<div className="col-2">
									<Select
										name="type"
										onChange={onTypeChange}
										options={[
											{
												value: 'week',
												label: 'Weekly',
											},
											{
												value: 'month',
												label: 'Monthly',
											},
											{
												value: 'year',
												label: 'Yearly',
											},
										]}
										value={type}
									/>
								</div>

								{type.value === 'week' && (
									<>
										<div className="col-3">
											<input
												key={rsKey}
												className="form-control"
												type="date"
												name="start"
												required
											/>
										</div>
										<div className="col-3">
											<input
												required
												key={reKey}
												className="form-control"
												type="date"
												name="end"
											/>
										</div>
									</>
								)}

								{type.value === 'month' && (
									<>
										<div className="col-2">
											<Select
												name="year"
												onChange={setOptionYear}
												options={optionsYear}
												value={optionYear}
												isSearchable
											/>
										</div>
										<div className="col-2">
											<Select
												name="monthFrom"
												onChange={(e) => {
													setOptionMonthFrom(e);
													setOptionMonthTo(e);
												}}
												options={optionsMonth}
												value={optionMonthFrom}
												isSearchable
											/>
										</div>
										<div className="col-2">
											<Select
												name="monthTo"
												onChange={setOptionMonthTo}
												options={optionsTo()}
												value={optionMonthTo}
												isSearchable
											/>
										</div>
									</>
								)}

								{type.value === 'year' && (
									<>
										<div className="col-3">
											<Select
												name="year"
												onChange={setOptionYear}
												options={optionsYear}
												value={optionYear}
												isSearchable
											/>
										</div>
										<div className="col-3">
											<Select
												name="year_to"
												onChange={setOptionYearTo}
												options={optionsYear}
												value={optionYearTo}
												isSearchable
											/>
										</div>
									</>
								)}

								<div className="col-3">
									<div className="row justify-content-left">
										<div className="col-6">
											<Btn
												onLoad={filter}
												class="btn waves-effect waves-light btn-primary"
												type="submit"
											>
												<i className="feather icon-search"></i>{' '}
												Apply
											</Btn>
										</div>
										<div className="col-6">
											<Btn
												onClick={onClear}
												class="btn waves-effect waves-light btn-primary"
												type="button"
											>
												<i className="feather icon-trash"></i>{' '}
												Clear
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
			{filter ? (
				<div class="d-flex align-items-center justify-content-center">
					<div class="spinner-grow" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</div>
			) : (
				<div className="row">
					{data.map((e) => (
						<div className="col-xl-6 col-md-12">
							<div className="card">
								<div className="card-header">
									<h5>
										{e.label}{' '}
										{e.label === 'consumptions' && '(L)'}
										{e.label === 'topUp' && '(R)'}
									</h5>
									<div className="card-header-right">
										{/* <i class="feather full-card icon-maximize"></i> */}
									</div>
								</div>
								<div className="card-block">
									<ResponsiveContainer
										width="95%"
										height={250}
									>
										<LineChart
											// width={420}
											// height={225}
											data={e.data}
											margin={{
												top: 15,
												right: 0,
												// left: 20,
												// bottom: 5,
											}}
										>
											<CartesianGrid strokeDasharray="3 3" />
											<XAxis
												dataKey="name"
												// angle={90}
												// dy={20}
												// dx={5}
												padding={{
													left: 30,
													right: 30,
												}}
											/>
											<YAxis />
											<Tooltip />
											{/* <Legend /> */}
											<Line
												type="monotone"
												dataKey="value"
												stroke="#8884d8"
												activeDot={{ r: 8 }}
											/>
											{/* <Line
											type="monotone"
											dataKey="uv"
											stroke="#82ca9d"
										/> */}
										</LineChart>
									</ResponsiveContainer>
								</div>
							</div>
						</div>
					))}
				</div>
			)}
		</MainPage>
	);
}
